// Country list for the nationality field: flag emoji, Portuguese name and the UI language
// we switch to when that nationality is selected (only where we have a translation).
export const COUNTRIES = [
  { code: 'PT', flag: '🇵🇹', name: 'Portugal', lang: 'pt' },
  { code: 'BR', flag: '🇧🇷', name: 'Brasil', lang: 'pt' },
  { code: 'AO', flag: '🇦🇴', name: 'Angola', lang: 'pt' },
  { code: 'MZ', flag: '🇲🇿', name: 'Moçambique', lang: 'pt' },
  { code: 'CV', flag: '🇨🇻', name: 'Cabo Verde', lang: 'pt' },
  { code: 'GW', flag: '🇬🇼', name: 'Guiné-Bissau', lang: 'pt' },
  { code: 'ST', flag: '🇸🇹', name: 'São Tomé e Príncipe', lang: 'pt' },
  { code: 'TL', flag: '🇹🇱', name: 'Timor-Leste', lang: 'pt' },
  { code: 'ES', flag: '🇪🇸', name: 'Espanha', lang: 'es' },
  { code: 'FR', flag: '🇫🇷', name: 'França', lang: 'fr' },
  { code: 'GB', flag: '🇬🇧', name: 'Reino Unido', lang: 'en' },
  { code: 'IE', flag: '🇮🇪', name: 'Irlanda', lang: 'en' },
  { code: 'US', flag: '🇺🇸', name: 'Estados Unidos', lang: 'en' },
  { code: 'CA', flag: '🇨🇦', name: 'Canadá', lang: 'en' },
  { code: 'DE', flag: '🇩🇪', name: 'Alemanha', lang: 'de' },
  { code: 'AT', flag: '🇦🇹', name: 'Áustria', lang: 'de' },
  { code: 'CH', flag: '🇨🇭', name: 'Suíça', lang: 'de' },
  { code: 'IT', flag: '🇮🇹', name: 'Itália', lang: 'it' },
  { code: 'BE', flag: '🇧🇪', name: 'Bélgica', lang: 'fr' },
  { code: 'LU', flag: '🇱🇺', name: 'Luxemburgo', lang: 'fr' },
  { code: 'NL', flag: '🇳🇱', name: 'Países Baixos', lang: 'en' },
  { code: 'DK', flag: '🇩🇰', name: 'Dinamarca', lang: 'en' },
  { code: 'SE', flag: '🇸🇪', name: 'Suécia', lang: 'en' },
  { code: 'NO', flag: '🇳🇴', name: 'Noruega', lang: 'en' },
  { code: 'FI', flag: '🇫🇮', name: 'Finlândia', lang: 'en' },
  { code: 'IS', flag: '🇮🇸', name: 'Islândia', lang: 'en' },
  { code: 'PL', flag: '🇵🇱', name: 'Polónia', lang: 'en' },
  { code: 'CZ', flag: '🇨🇿', name: 'Chéquia', lang: 'en' },
  { code: 'SK', flag: '🇸🇰', name: 'Eslováquia', lang: 'en' },
  { code: 'HU', flag: '🇭🇺', name: 'Hungria', lang: 'en' },
  { code: 'RO', flag: '🇷🇴', name: 'Roménia', lang: 'en' },
  { code: 'BG', flag: '🇧🇬', name: 'Bulgária', lang: 'en' },
  { code: 'GR', flag: '🇬🇷', name: 'Grécia', lang: 'en' },
  { code: 'HR', flag: '🇭🇷', name: 'Croácia', lang: 'en' },
  { code: 'SI', flag: '🇸🇮', name: 'Eslovénia', lang: 'en' },
  { code: 'RS', flag: '🇷🇸', name: 'Sérvia', lang: 'en' },
  { code: 'UA', flag: '🇺🇦', name: 'Ucrânia', lang: 'en' },
  { code: 'MD', flag: '🇲🇩', name: 'Moldávia', lang: 'en' },
  { code: 'TR', flag: '🇹🇷', name: 'Turquia', lang: 'en' },
  { code: 'RU', flag: '🇷🇺', name: 'Rússia', lang: 'en' },
  { code: 'AR', flag: '🇦🇷', name: 'Argentina', lang: 'es' },
  { code: 'MX', flag: '🇲🇽', name: 'México', lang: 'es' },
  { code: 'CL', flag: '🇨🇱', name: 'Chile', lang: 'es' },
  { code: 'CO', flag: '🇨🇴', name: 'Colômbia', lang: 'es' },
  { code: 'PE', flag: '🇵🇪', name: 'Peru', lang: 'es' },
  { code: 'VE', flag: '🇻🇪', name: 'Venezuela', lang: 'es' },
  { code: 'UY', flag: '🇺🇾', name: 'Uruguai', lang: 'es' },
  { code: 'PY', flag: '🇵🇾', name: 'Paraguai', lang: 'es' },
  { code: 'BO', flag: '🇧🇴', name: 'Bolívia', lang: 'es' },
  { code: 'EC', flag: '🇪🇨', name: 'Equador', lang: 'es' },
  { code: 'CR', flag: '🇨🇷', name: 'Costa Rica', lang: 'es' },
  { code: 'PA', flag: '🇵🇦', name: 'Panamá', lang: 'es' },
  { code: 'DO', flag: '🇩🇴', name: 'República Dominicana', lang: 'es' },
  { code: 'CU', flag: '🇨🇺', name: 'Cuba', lang: 'es' },
  { code: 'MA', flag: '🇲🇦', name: 'Marrocos', lang: 'fr' },
  { code: 'DZ', flag: '🇩🇿', name: 'Argélia', lang: 'fr' },
  { code: 'TN', flag: '🇹🇳', name: 'Tunísia', lang: 'fr' },
  { code: 'SN', flag: '🇸🇳', name: 'Senegal', lang: 'fr' },
  { code: 'CI', flag: '🇨🇮', name: 'Costa do Marfim', lang: 'fr' },
  { code: 'CM', flag: '🇨🇲', name: 'Camarões', lang: 'fr' },
  { code: 'ZA', flag: '🇿🇦', name: 'África do Sul', lang: 'en' },
  { code: 'NG', flag: '🇳🇬', name: 'Nigéria', lang: 'en' },
  { code: 'GH', flag: '🇬🇭', name: 'Gana', lang: 'en' },
  { code: 'KE', flag: '🇰🇪', name: 'Quénia', lang: 'en' },
  { code: 'EG', flag: '🇪🇬', name: 'Egito', lang: 'en' },
  { code: 'AE', flag: '🇦🇪', name: 'Emirados Árabes Unidos', lang: 'en' },
  { code: 'SA', flag: '🇸🇦', name: 'Arábia Saudita', lang: 'en' },
  { code: 'IL', flag: '🇮🇱', name: 'Israel', lang: 'en' },
  { code: 'IN', flag: '🇮🇳', name: 'Índia', lang: 'en' },
  { code: 'PK', flag: '🇵🇰', name: 'Paquistão', lang: 'en' },
  { code: 'BD', flag: '🇧🇩', name: 'Bangladeche', lang: 'en' },
  { code: 'CN', flag: '🇨🇳', name: 'China', lang: 'en' },
  { code: 'JP', flag: '🇯🇵', name: 'Japão', lang: 'en' },
  { code: 'KR', flag: '🇰🇷', name: 'Coreia do Sul', lang: 'en' },
  { code: 'TH', flag: '🇹🇭', name: 'Tailândia', lang: 'en' },
  { code: 'VN', flag: '🇻🇳', name: 'Vietname', lang: 'en' },
  { code: 'PH', flag: '🇵🇭', name: 'Filipinas', lang: 'en' },
  { code: 'ID', flag: '🇮🇩', name: 'Indonésia', lang: 'en' },
  { code: 'MY', flag: '🇲🇾', name: 'Malásia', lang: 'en' },
  { code: 'SG', flag: '🇸🇬', name: 'Singapura', lang: 'en' },
  { code: 'AU', flag: '🇦🇺', name: 'Austrália', lang: 'en' },
  { code: 'NZ', flag: '🇳🇿', name: 'Nova Zelândia', lang: 'en' },
  { code: 'OTHER', flag: '🌍', name: 'Outra', lang: null }
];

export const findCountry = (code) => COUNTRIES.find((c) => c.code === code);

// Strip accents so "Mocambique" also matches "Moçambique"
export const normalise = (value) =>
  (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
